/** @format */
import { PostFormDataAPI } from "./../api/request";
import { GenerateIdeasProps } from "interfaces/payloads/GenerateIdeas";
import { GetAPI } from "api/request";

export interface useInteriorDesignProps {
  upperGarmentImageUrl: string;
  lowerGarmentImageUrl: string;
  generatedImageHistory: [];
  generatedImageUrl: string;
  isNewUser: boolean;
  previewImageUrl: string;
  uploadedGarmentsHistory: [];
  generatedImage: (formData: GenerateIdeasProps) => Promise<any>;
  getAllGeneratedImages: () => Promise<any>;
  setUpperGarmentImageUrl: (imageUrl: string) => void;
  setLowerGarmentImageUrl: (imageUrl: string) => void;
  clearUpperGarmentImageUrl: (imageUrl: string) => void;
  clearLowerGarmentImageUrl: (imageUrl: string) => void;
  updateNewUser: (value: boolean) => void;
  setPreviewImageUrl: (imageUrl: string) => void;
  setGenerateImageUrl: () => void;
}

export const useInteriorDesignStore = (
  set: any,
  get: any
): useInteriorDesignProps => ({
  // https://i.pinimg.com/originals/aa/72/ff/aa72ffa16eaaf2d6833caa86d8f4e56c.jpg
  isNewUser: false,
  upperGarmentImageUrl: "",
  lowerGarmentImageUrl: "",
  generatedImageHistory: [],
  uploadedGarmentsHistory: [],
  generatedImageUrl: "",
  previewImageUrl: "",
  setGenerateImageUrl: () => {
    set({
      generatedImageUrl: "",
    });
  },
  clearUpperGarmentImageUrl: () => {
    set({
      upperGarmentImageUrl: "",
    });
  },
  clearLowerGarmentImageUrl: () => {
    set({
      lowerGarmentImageUrl: "",
    });
  },
  updateNewUser: (value: boolean) => {
    set({
      isNewUser: value,
    });
  },
  setUpperGarmentImageUrl: (imageUrl: string) => {
    set({
      upperGarmentImageUrl: imageUrl,
    });
  },
  setLowerGarmentImageUrl: (imageUrl: string) => {
    set({
      lowerGarmentImageUrl: imageUrl,
    });
  },
  generatedImage: (formData: any) => {
    return new Promise((resolve, reject) => {
      PostFormDataAPI(`imagine_interior/images/create_image`, formData)
        .then((response: any) => {
          const imageUrl = response.data.processed_image_url;
          set({
            generatedImageUrl: imageUrl,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllGeneratedImages: async () => {
    return new Promise((resolve, reject) => {
      GetAPI(`imagine_interior/images/get_customer_images`)
        .then((response: any) => {
          const cloudinaryUrls = response?.data?.map(
            (image: any) => image.processed_image_url
          );
          const uploadedGarments = response?.data?.map(
            (image: any) => image.upper_garment_image_url
          );
          console.log(uploadedGarments, "uploadedGarments");
          set({
            generatedImageHistory: cloudinaryUrls,
            uploadedGarmentsHistory: uploadedGarments,
          });
          resolve(cloudinaryUrls);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },
  setPreviewImageUrl: (imageUrl: string) => {
    set({
      previewImageUrl: imageUrl,
    });
  },
});
